import { REMIND_MAIL_ENGLISH_ORDER_LABEL, REMIND_MAIL_JAPANESE_ORDER_LABEL } from '@/remindModule/constants';
import { getUserId } from '@/awsCodes/awsUtils';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { getMemberListProc } from '@/appLogic/leanpath/wrappers';
import { IDate } from '@/coreDomainsModule/date';

/**
 * リマインダーの更新登録を行う際、リマインダーに登録する情報の作成・更新を行う
 */
export class ReminderInfoService {
  /**
   * リマインドメールのフォームテキスト添付用、発注情報をまとめる関数
   * @param businessInfo - 取引情報
   */
  public static createOrderInfoFormText = (businessInfo: IBusiness): string => {
    const targetReminderLabel = [REMIND_MAIL_JAPANESE_ORDER_LABEL, REMIND_MAIL_ENGLISH_ORDER_LABEL];
    let output = '';

    // 対象のラベルをループさせる
    targetReminderLabel.forEach((targetLabel, index) => {
      if (index === 0) {
        output = '\n' + targetLabel; // 出力文字列を入れる (初期値にラベル情報を入力しておく)
      } else {
        output += '\n\n' + targetLabel; // 英語のラベルを追加
      }

      // 確定発注情報が空の時は発注情報を記載せず、取引に関わる情報のみを文字列として出力する
      if (businessInfo.recommend.length === 0) {
        output +=
          '\n' +
          `${'[No input]'} / ` +
          `${'[No input]'} / ` +
          `${businessInfo.warehouse} / ` +
          `${businessInfo.supplierName} / ` +
          `${businessInfo.businessNumber} / ` +
          `${businessInfo.businessName} / ` +
          `${businessInfo.package}`;
        return;
      }

      // 登録した確定発注情報をすべて記載するための文字列を作成する
      for (const orderInfo of businessInfo.recommend) {
        // 発注数量を引っ張ってくる
        const orderAmount = orderInfo.amount;
        // 納入日の初期値
        const crossDate: IDate = {
          year: 9999,
          month: 0,
          day: 0,
        };
        // 登録済み納入日を引っ張ってくる
        if (orderInfo.crossDate) {
          crossDate.year = orderInfo.crossDate?.year;
          crossDate.month = orderInfo.crossDate?.month;
          crossDate.day = orderInfo.crossDate?.day;
        }
        const orderYearMonthDate: Date = new Date(crossDate.year, crossDate.month - 1, crossDate.day); // Date型に月情報を渡すときは0~11の範囲
        const orderDate = DateService.getDisplayYearMonthDay(orderYearMonthDate);
        output +=
          '\n' +
          `${orderAmount.addComma()} / ` +
          `${orderDate} / ` +
          `${businessInfo.warehouse} / ` +
          `${businessInfo.supplierName} / ` +
          `${businessInfo.businessNumber} / ` +
          `${businessInfo.businessName} / ` +
          `${businessInfo.package}`;
      }
    });
    // 出力
    return output;
  };
}
